module.exports = __webpack_public_path__ + "img/07-JS-design-a-winning-cover-letter.df7ef264.svg";